var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseInstructor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11C12.6506 11 15 8.65063 15 5.75C15 2.84938 12.6506 0.5 9.75 0.5C6.84938 0.5 4.5 2.84938 4.5 5.75C4.5 8.65063 6.84938 11 9.75 11ZM26.25 8.375C26.25 10.654 24.404 12.5 22.125 12.5C19.846 12.5 18 10.654 18 8.375C18 6.0959 19.846 4.25 22.125 4.25C24.404 4.25 26.25 6.0959 26.25 8.375ZM9.75 12.5C11.8002 12.5 15.1373 13.1383 17.3258 14.4089C18.2198 15.3189 18.75 16.3111 18.75 17.3V21.5H0V17.3C0 14.108 6.4959 12.5 9.75 12.5ZM30 21.5H20.25V17.3C20.25 16.2378 19.8665 15.2601 19.2573 14.3874C20.413 14.1294 21.5507 14 22.4195 14C25.2158 14 30 15.34 30 18V21.5Z",
    fill: "#663399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseInstructor);
export default __webpack_public_path__ + "static/media/courseInstructor.ae222fc595d11531c70e9eb22a699af1.svg";
export { ForwardRef as ReactComponent };